import React from "react";
import { socialPhotos } from "../data/photos";
import { business } from "../data/business";
import { useSite } from "../hooks/useSite";

// Shared social strip: outline/solid heading left, three offset square
// photographs right. Each opens the keyboard-operable gallery.
export default function SocialStrip() {
  const { openModal } = useSite();
  return (
    <section className="ro-social-strip" aria-labelledby="ro-social-heading">
      <div className="ro-container ro-social-strip__grid">
        <h2 id="ro-social-heading">
          <span className="ro-outline">Follow us on Instagram</span>
          <br />
          <strong className="ro-italic">{business.hashtag}</strong>
        </h2>
        <div className="ro-social-strip__images">
          {socialPhotos.map((p, i) => (
            <button
              key={p.src}
              type="button"
              className="ro-social-strip__image"
              onClick={() => openModal("gallery", { index: i, source: "social" })}
              aria-label={`Open photo: ${p.alt}`}
            >
              <img src={p.src} alt="" width="300" height="300" loading="lazy" />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
